/**
 * Created by rlopez on 19/01/17.
 */

// NotificationDetailsView.js

import $ from 'jquery';

import { View,Model } from 'backbone';
import eventBus  from 'EventBus';

import contentTemplate  from 'dashboard/notifications/notification-details-view.ejs';
import PlayFormModal        from 'common-views/PlayFormModal.js';
import RestService from 'RestService.js';
import constants        from 'Constants.js';
import util      from 'util/Util.js';

class NotificationDetailsView extends View {

    initialize( opts ) {

        this.options = opts || {};
        this.template = contentTemplate;

        this.events = {
            'click button[name=viewForm]':'viewForm',
            'click #goToNotifications': 'goToNotifications',
            'click #goToNotification': 'goToNotificationDetail'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    viewForm(){
        const notificationDetails = this.model.get('notificationDetails');
        const linkId = notificationDetails.NotificationId;
        let instanceUrl = RestService.getLinkUrl(linkId) + '&viewForm=true' + 
            (util.isTrue(notificationDetails.IsDraft) ? '&isDraft=1' : '');
        const attributes = {url: instanceUrl, id: linkId };
        const newPlayForm = new PlayFormModal({model: new Model(attributes) });
        newPlayForm.render().then((result) => {});
    }

    render() {
        let messageBody = this.model.get('notificationDetails').MessageBody ? this.model.get('notificationDetails').MessageBody['#cdata-section'] : '';
        let htmlMessageBody = this.model.get('notificationDetails').HtmlMessageBody ? this.model.get('notificationDetails').HtmlMessageBody['#cdata-section'] : '';
        const html = this.template( this.model.toJSON() );
        let textIsEmpty = false;
        $(this.$el[0]).html( html );
        if (messageBody){
            $('#txtBody').html(messageBody);
        }else{
            $('#messageTextLI').remove();
            textIsEmpty = true;
        }
        
        //Force all links to open in a new tab
        let notificationBodylinks = $('#txtBody a');
        $.each(notificationBodylinks, (index, _link) => {
            $(_link).attr('target', '_blank');
        });

        if (htmlMessageBody){
            if (textIsEmpty){
                $('#messageHtmlLI a').trigger('click');
            }

            htmlMessageBody = util.removeScriptsFromHTMLString(htmlMessageBody);
            const divParent = document.createElement('div');
            $(divParent).append(htmlMessageBody);
            $(divParent).css({
                'font': '12px Roboto, sans-serif',
                '-webkit-user-select': 'none',
                '-moz-user-select': 'none',
                '-ms-user-select': 'none',
                'user-select': 'none'
            });
            notificationBodylinks = $(divParent).find('a');
            $.each(notificationBodylinks, (index, _link) => {
                $(_link).attr('target', '_blank');
            });

            const iframeElement = document.createElement('iframe');
            iframeElement.srcdoc = divParent.outerHTML;
            iframeElement.style.border = 'none';
            iframeElement.setAttribute("sandbox", "allow-popups allow-popups-to-escape-sandbox"); //To avoid malicious code to be executed
            iframeElement.width = '100%';
            iframeElement.height = '300px';
            $('#txtBodyHtml').append(iframeElement);
            
        }else{         
            $('#messageHtmlLI').remove();
        }

        this.delegateEvents();
        this.$el.css( 'cursor', 'default' );

        return this;
    }

    refresh(){
        let notificationId=this.model.get('notificationDetails').NotificationId;
        eventBus.trigger(constants.EV_SHOW_NOTIFICATION_DETAILS,notificationId);
    }

    goToNotifications(e) {
         e.preventDefault();
         e.stopPropagation(); 

         eventBus.trigger('loadNotificationsView');
    }

    goToNotificationDetail(e) {
         e.preventDefault();
         e.stopPropagation(); 

        eventBus.trigger(constants.EV_SHOW_ATTENTION_NOTIFICATION_DASHBOARD, undefined, this.model.get('groupType') === 'attentionNeeded');
        
    } 
}

export default NotificationDetailsView;

